<template>
  <modal :name="name" adaptive height="auto" @before-open="beforeOpen">
    <Wrapper>
      <template v-slot:header-title>
        {{ $t(title) }}
      </template>
      <div>
        {{ $t(body) }}
      </div>
      <div class="btn--bar">
        <button type="button" @click="$emit('confirmed', params)"
                class="btn">
          <i class="icon--check"></i> {{ $t(actionKey) }}
        </button>
        <span class="btn btn--secondary" @click="$modal.hide(name)"><i class="icon--cancel"></i> {{ $t('general.close') }}</span>
      </div>
    </Wrapper>
  </modal>
</template>

<script>
import Wrapper from '@/components/Modal/Wrapper'

export default {
  name: 'Confirm',
  props: {
    name: {
      type: String,
      default: 'confirmation'
    },
    body: {
      type: String,
      default: 'general.are_you_sure'
    },
    actionKey: {
      type: String,
      default: 'general.delete'
    },
    title: {
      type: String,
      default: 'general.alert'
    }
  },
  components: { Wrapper },
  data () {
    return {
      params: {}
    }
  },
  computed: {},
  methods: {
    beforeOpen (event) {
      this.params = { ...event.params }
    }
  }
}
</script>

<style scoped>

</style>
